import React from 'react';
import MainComponent from './components/MainComponent'
import './App.css';
import 'antd/dist/antd.css'
//import QRCodes from './components/Products/ProductRestock/QRCodes'


function App() {
  
    return <MainComponent/>
//   return <QRCodes/>
  
}

export default App;
